<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { Button, Uploader } from 'vant';
export default {
  name: "HelloWorld",
  components: {
    Button,
    Uploader
  },
  props: {
    msg: String,
  },
  data(){
    return {
  
    }
  },
  mounted() {

   
  },
  watch: {
    // 监听路由对象的变化（包括路径、参数等任何变化）
    $route() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  methods: {
   
  },
};
</script>


<style lang="less">
#app {
  height: 100%;
  width: 100%;
}
</style>
